import { CheckSquareIcon } from '@shared/assets/icons';
import styles from './styles.module.scss';
import { Button } from '@shared/ui/kit';

interface EventStartedSendProps {
  onClose: () => void;
  title?: string;
  description?: string;
}

export const EventStartedSend = ({
  onClose,
  title = 'Начали отправку приглашений',
  description = 'Прогресс можно отслеживать на странице мероприятия',
}: EventStartedSendProps) => {
  return (
    <div className={styles.container}>
      <CheckSquareIcon />

      <div className={styles.info}>
        <span className={styles.title}>{title}</span>
        <span className={styles.description}>{description}</span>
      </div>

      <Button variant="accent" onClick={onClose} settings={{ padding: '8px 24px', fontSize: '18px' }}>
        К мероприятию
      </Button>
    </div>
  );
};
